// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-banner[data-v-3e6242d5]{margin:0 1.5rem}#cancel-button[data-v-3e6242d5]{padding:0;margin-right:1.5rem;color:#46aff2}#submit-button[data-v-3e6242d5]{background-color:#1774cc;color:#fff}#submit-button.warning-button[data-v-3e6242d5]{background-color:#d93b3d}", ""]);
// Exports
module.exports = exports;
